import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDeleteThreadMutation } from 'modules/threads/threadsApi';
import { showSuccessMessage, showUncaughtErrorMessage } from 'modules/alert/utils';
import { handleApiCall } from 'utils/helpers';
import { NOTIFICATION } from 'modules/alert/constants';
import { Group, Stack, Text } from 'ui';
import { IThreadMOdalsDefaultProps } from 'types';
import routes from 'constants/routes';
import colors from 'theme/colors';
import { useModal } from 'modules/modals/ModalProvider';
import { Button } from 'components/ui/button';

const RemoveThread: React.FC<IThreadMOdalsDefaultProps> = ({ threadId, threadName }) => {
  const { close } = useModal();
  const [deleteThread, { isLoading }] = useDeleteThreadMutation();
  const navigate = useNavigate();

  const handleDeleteThread = async () => {
    const res = await deleteThread(threadId as string);
    handleApiCall(
      res,
      () => showUncaughtErrorMessage(),
      () => {
        close();
        showSuccessMessage(NOTIFICATION.THREAD_DELETED);
        navigate(routes.dashboard);
      }
    );
  };

  return (
    <Stack gap="20px">
      <Text size="lg" color={colors.gray2}>
        Are you sure you want to delete {threadName || 'this'} thread?
      </Text>
      <Group justify="end" gap="15px">
        <Button variant="secondary" onClick={close} data-cy="modal-remove-thread-cancel-btn">
          Cancel
        </Button>
        <Button
          variant="destructive"
          disabled={isLoading}
          onClick={handleDeleteThread}
          data-cy="modal-remove-thread-delete-btn"
        >
          {isLoading ? 'Deleting...' : 'Delete'}
        </Button>
      </Group>
    </Stack>
  );
};

export default RemoveThread;
